import { render, staticRenderFns } from "./MentionSectionBloc.vue?vue&type=template&id=8c7745da&"
import script from "./MentionSectionBloc.vue?vue&type=script&lang=js&"
export * from "./MentionSectionBloc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports